import cn from 'classnames';
import { FormEvent, HTMLAttributes, useState } from 'react';
import { UiButton } from '@@/ui/components/ui-button';

import styles from './index.module.sass';

export function CreateWarehouseStep(props: ICreateWarehouseStepProps) {
  const { className, contentClassName, children, prev, next, onPrev, onNext, ...rest } =
    props;
  const rootClass = cn(styles.root, className);
  const contentClass = cn(styles.content, contentClassName);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsLoading(true);
    await onNext();
    setIsLoading(false);
  };

  return (
    <form className={rootClass} onSubmit={onSubmit} {...rest}>
      <div className={contentClass}>{children}</div>

      <div className={styles.actions}>
        <UiButton
          label={prev?.label ?? 'назад'}
          view="clear"
          disabled={prev?.disabled}
          onClick={onPrev}
        />
        <UiButton
          label={next?.label ?? 'перейти след. шаг'}
          disabled={next?.disabled}
          type="submit"
          loading={isLoading}
        />
      </div>
    </form>
  );
}

export interface ICreateWarehouseStepProps
  extends Omit<HTMLAttributes<HTMLFormElement>, 'onSubmit'> {
  contentClassName?: string;
  prev?: {
    label?: string;
    disabled?: boolean;
  };
  next?: {
    label?: string;
    disabled?: boolean;
  };
  onPrev?: () => void | Promise<void>;
  onNext: () => void | Promise<void>;
}
